module.exports = __webpack_public_path__ + "static/media/amr111.334c84eb.jpg";